/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-04-15",
    versionChannel: "nightly",
    buildDate: "2024-04-15T00:49:14.094Z",
    commitHash: "fd1b6f59f245fa978f97b9697a99cd01bd59d7d5",
};
